export var FormActions;
(function (FormActions) {
    FormActions["Create"] = "CREATE";
    FormActions["Edit"] = "EDIT";
})(FormActions || (FormActions = {}));
